<template>
  <div class="tab-content pb-l">    
    <!-- <transition name="slide-fade" appear mode="out-in"> -->
    <keep-alive :max="6">
      <img
        v-if="tabType === 'tab-image'"
        @load="imgLoaded"
        :src="`${$imageFolder}/${children[0].image}`"
        alt=""
      />      
      <content-block
        class="text--m"
        v-else-if="tabType === 'tab-content'"
        v-bind="{ content }"
        exclude-title
        embedded
      ></content-block>
      <slider
        v-else-if="tabType === 'tab-gallery'"
        v-bind="{ children }"
        is-gallery
        :auto="false"
      ></slider>
    </keep-alive>
    <!-- </transition> -->
    <div
      v-if="tabType === 'tab-image' && content"
      class="tab-content--text"
      v-html="content"
    ></div>
  </div>
</template>
<script>
// import Content from "@/components/Content.vue";

export default {
  props: {
    type: {
      type: String,
      required: true
    },
    content: {
      type: String,
      default: ""
    },
    children: {
      type: Array,
      required: true
    },
    tabIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tabType: null
    };
  },
  watch: {
    tabIndex() {
      console.log("tab  changed...", this.type);
      this.$emit("tab-changed");
      this.tabType = null;
      this.$nextTick(function() {
        setTimeout(
          function() {
            this.tabType = this.type;
          }.bind(this),
          400
        );
      });
    }
  },
  mounted() {
    this.tabType = this.type;
  },
  methods: {
    imgLoaded(e) {
      console.log("img loaded > ", e);
      this.$emit("img-loaded");
    }
  }
};
</script>
<style lang="stylus">
.fade-left-leave-active
.fade-right-leave-active
  position absolute !important
.tab-content
  position relative
  overflow hidden
  _flex(row, nowrap, flex-start, center)
  height 100%
  .content-block
    width 100%
    //max-height 50vh
    //overflow auto
  img
    max-width 50%
  & > *
    max-width 100%
    max-height 100%
    &:first-child:last-child
      max-width 100% !important

    // padding 2% 5%
    // flex 1
    &.slider-gallery
      width 100% !important
      height auto !important
      .slider-items
        margin-bottom 35px
        overflow hidden
        _flex(row, wrap, flex-start, flex-start)
        // max-height 54vh


      .slider-item
        position static
        height auto
        min-height 100%
        _flex(column, wrap, flex-start, flex-start)
        // position relative
        padding 0 2vw
        +below(600px)
          padding 0 0 // padding 0 8vw (dubix changes)
      .slider-indicator-active
        background gray_2
  // & > *:first-child:last-child
  //   center()
  &--text
    text-align left
    transform translateY(50%)
</style>
